import React from 'react';

const PercentFmt = ({ children }) => {
    // Convert children to a float
    const floatStr = children;
    let formattedPercentage;

    try {
        const parsedFloat = parseFloat(floatStr);
        
        // Check if the parsed value is a valid float
        if (isNaN(parsedFloat)) {
            throw new Error('Invalid float');
        }

        // Convert float to percentage (multiply by 100) and format it with a percentage sign
        formattedPercentage = `${(parsedFloat * 100).toFixed(0)}%`;
    } catch (error) {
        console.error(error);
        return <span>Invalid percentage</span>;
    }

    return (
        <span className="percent-format">{formattedPercentage}</span>
    );
};

export default PercentFmt;
